module.exports = __webpack_public_path__ + "img/just-add-fans.df8a1885.png";